import { useMemo } from 'react'
import { uniqueId } from 'lodash-es'

import { CardDetailsList } from 'Components/CardDetailsList/CardDetailsList'
import { CardDetailsListItem } from 'Components/CardDetailsList/CardDetailsList.types'
import { ContentCard } from 'Components/ContentCard/ContentCard'
import { FormatDate } from 'Components/FormatDate/FormatDate'

import { getFullContactName } from 'Utilities'

import { OrderIntercomButton } from '../OrderIntercomButton/OrderIntercomButton'
import { OrderDetailsCardProps } from './OrderDetailsCard.types'

export const OrderDetailsCard = (props: OrderDetailsCardProps) => {
  const { caseItem, title } = props

  const filteredEmployeesList = useMemo(
    () =>
      caseItem.data.requestedPhonePlan?.employees?.filter(
        employeeName => employeeName,
      ),
    [caseItem],
  )

  const employeesLabel = useMemo(
    () =>
      filteredEmployeesList?.length === 1
        ? 'PhonePlanListContent_header__employee'
        : 'Employees',
    [filteredEmployeesList],
  )

  const employeesValue = useMemo(
    () =>
      !filteredEmployeesList?.length ? undefined : (
        <ul className="CardDetailsList-employees-list">
          {filteredEmployeesList.map(employeeName => (
            <li key={uniqueId()}>{employeeName}</li>
          ))}
        </ul>
      ),
    [filteredEmployeesList],
  )

  const generateDetailsCardListItems = useMemo(
    (): CardDetailsListItem[] => [
      {
        label: 'RequestDetails_request_id',
        value: caseItem.id,
      },
      {
        label: 'RequestDetails_agent',
        value: getFullContactName(caseItem.assignedUser, false),
      },
      {
        label: 'RequestDetails_date',
        value: <FormatDate value={caseItem.created} />,
      },
      {
        label: 'RequestDetails_customerLabel',
        value: caseItem.customerLabel,
      },
      {
        label: employeesLabel,
        value: employeesValue,
      },
      {
        label: 'Phone_plan',
        value: caseItem.data.requestedPhonePlan?.name,
      },
      {
        label: 'Quantity',
        value: caseItem.data.requestedPhonePlan?.number?.toString(),
      },
      {
        label: 'Created_by',
        value: getFullContactName(caseItem.user, false),
      },
    ],
    [caseItem, employeesLabel, employeesValue],
  )

  return (
    <ContentCard className="OrderDetailsCard" title={title}>
      <CardDetailsList
        className="mb-4"
        listItems={generateDetailsCardListItems}
      />

      <OrderIntercomButton caseItemId={caseItem.id} />
    </ContentCard>
  )
}
